import { useEffect, useState } from "react";

const ModeBtn = ({classes})=>{
   const [darkMode , setDarkMode] = useState(false);
   
    const toggleDark = ()=>{
        let created= document.getElementsByTagName('body')[0].classList.toggle('dark');
         if(created){
            setDarkMode(true)
           localStorage.setItem('isDarkMode',true);
         }else{
           localStorage.setItem('isDarkMode',false);
           setDarkMode(false)
         }
       }

       
  const checkDarkMode = ()=>{
    if(localStorage.getItem('isDarkMode') == 'true'){
      setDarkMode(true)
    }
  }
  useEffect(()=>{checkDarkMode()},[])
    
       
    return(
    <div >
      <div className="text-black pt-2 dark:text-white">
        <button onClick={ toggleDark}>
          {!darkMode ? (
            <svg className={classes} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
              />
            </svg>
          ) : (
            <svg className={classes} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
export default ModeBtn;